// src/pages/AdminPanelStyles.jsx - KAPSAMLI CSS STİLLERİ (İptal & İade Dahil)
import React from 'react';

export default function AdminPanelStyles() {
  return (
    <style jsx global>{`
      /* ==================== GLOBAL RESET ==================== */
      * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
      }

      /* ==================== ADMIN PANEL LAYOUT ==================== */
      .admin-panel {
        display: flex;
        flex-direction: column;
        min-height: 100vh;
        background: #f5f7fa;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 
          'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
      }

      /* ==================== HEADER ==================== */
      .admin-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: white;
        padding: 1rem 2rem;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        position: sticky;
        top: 0;
        z-index: 100;
      }

      .header-left {
        display: flex;
        align-items: center;
        gap: 1rem;
      }

      .menu-btn {
        display: none;
        background: none;
        border: none;
        cursor: pointer;
        padding: 0.5rem;
        color: #2B2B2B;
      }

      .admin-header h1 {
        font-size: 20px;
        font-weight: 700;
        color: #2B2B2B;
      }

      .header-right {
        display: flex;
        align-items: center;
        gap: 1rem;
      }

      .notification-btn {
        position: relative;
        background: none;
        border: none;
        cursor: pointer;
        padding: 0.5rem;
        border-radius: 8px;
        transition: all 0.2s;
      }

      .notification-btn:hover {
        background: #f8f9fa;
      }

      .notification-badge {
        position: absolute;
        top: 4px;
        right: 4px;
        background: #E5332A;
        color: white;
        font-size: 10px;
        font-weight: 700;
        padding: 2px 6px;
        border-radius: 10px;
        min-width: 18px;
        text-align: center;
      }

      .user-name {
        font-size: 14px;
        font-weight: 600;
        color: #495057;
      }

      .avatar {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background: linear-gradient(135deg, #E5332A, #ff6b6b);
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 700;
        font-size: 14px;
      }

      /* ==================== LAYOUT ==================== */
      .admin-layout {
        display: flex;
        flex: 1;
        position: relative;
      }

      /* ==================== SIDEBAR ==================== */
      .sidebar-overlay {
        display: none;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.5);
        z-index: 998;
      }

      .sidebar {
        width: 260px;
        background: white;
        padding: 2rem 1rem;
        box-shadow: 2px 0 8px rgba(0, 0, 0, 0.08);
        overflow-y: auto;
        position: sticky;
        top: 72px;
        height: calc(100vh - 72px);
        transition: transform 0.3s ease;
      }

      .nav-section {
        margin-bottom: 2rem;
      }

      .nav-section-title {
        font-size: 11px;
        font-weight: 700;
        text-transform: uppercase;
        color: #868e96;
        padding: 0 1rem;
        margin-bottom: 0.75rem;
        letter-spacing: 0.5px;
      }

      .nav-btn {
        display: flex;
        align-items: center;
        gap: 0.75rem;
        width: 100%;
        padding: 0.875rem 1rem;
        background: none;
        border: none;
        cursor: pointer;
        border-radius: 8px;
        transition: all 0.2s;
        color: #495057;
        font-size: 14px;
        font-weight: 500;
        position: relative;
      }

      .nav-btn:hover {
        background: #f8f9fa;
        color: #E5332A;
      }

      .nav-btn.active {
        background: linear-gradient(135deg, rgba(229, 51, 42, 0.1), rgba(255, 107, 107, 0.1));
        color: #E5332A;
        font-weight: 600;
      }

      .nav-label {
        flex: 1;
        text-align: left;
      }

      .nav-badge {
        background: #E5332A;
        color: white;
        font-size: 11px;
        font-weight: 700;
        padding: 2px 8px;
        border-radius: 10px;
        min-width: 20px;
        text-align: center;
      }

      /* ==================== MAIN CONTENT ==================== */
      .main-content {
        flex: 1;
        padding: 2rem;
        overflow-y: auto;
      }

      .page-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 2rem;
      }

      .page-title {
        font-size: 28px;
        font-weight: 700;
        color: #2B2B2B;
      }

      /* ==================== STATS GRID ==================== */
      .stats-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
        gap: 1.5rem;
        margin-bottom: 2rem;
      }

      .stat-card {
        background: white;
        padding: 1.5rem;
        border-radius: 12px;
        border: 2px solid #e9ecef;
        transition: all 0.3s ease;
      }

      .stat-card:hover {
        transform: translateY(-4px);
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
      }

      .stat-card-inner {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .stat-label {
        font-size: 13px;
        color: #868e96;
        margin-bottom: 0.5rem;
        font-weight: 500;
      }

      .stat-value {
        font-size: 28px;
        font-weight: 700;
        color: #2B2B2B;
        margin-bottom: 0.25rem;
      }

      .stat-subtext {
        font-size: 12px;
        color: #868e96;
      }

      .stat-icon {
        width: 56px;
        height: 56px;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      /* ==================== TOOLBAR ==================== */
      .toolbar {
        display: flex;
        flex-wrap: wrap;
        gap: 1rem;
        align-items: center;
        background: white;
        padding: 1rem;
        border-radius: 12px;
        margin-bottom: 2rem;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
      }

      .search-bar {
        display: flex;
        align-items: center;
        gap: 0.75rem;
        background: #f8f9fa;
        padding: 0.75rem 1rem;
        border-radius: 8px;
        flex: 1;
        min-width: 250px;
      }

      .search-bar input {
        flex: 1;
        background: none;
        border: none;
        outline: none;
        font-size: 14px;
        color: #2B2B2B;
      }

      .search-bar input::placeholder {
        color: #868e96;
      }

      .toolbar-divider {
        width: 1px;
        height: 32px;
        background: #e9ecef;
      }

      .toolbar-section {
        display: flex;
        gap: 0.75rem;
        align-items: center;
        flex-wrap: wrap;
      }

      .select-wrapper {
        position: relative;
      }

      .select {
        padding: 0.75rem 2.5rem 0.75rem 1rem;
        border: 1px solid #e9ecef;
        border-radius: 8px;
        font-size: 14px;
        font-weight: 500;
        color: #495057;
        background: white;
        cursor: pointer;
        transition: all 0.2s;
        appearance: none;
      }

      .select:hover {
        border-color: #E5332A;
      }

      .select:focus {
        outline: none;
        border-color: #E5332A;
        box-shadow: 0 0 0 3px rgba(229, 51, 42, 0.1);
      }

      /* ==================== BUTTONS ==================== */
      .btn {
        display: inline-flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0.75rem 1.25rem;
        border-radius: 8px;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s;
        border: none;
        white-space: nowrap;
      }

      .btn-primary {
        background: linear-gradient(135deg, #E5332A, #ff6b6b);
        color: white;
      }

      .btn-primary:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(229, 51, 42, 0.3);
      }

      .btn-primary:disabled {
        opacity: 0.6;
        cursor: not-allowed;
        transform: none;
      }

      .btn-outline {
        background: white;
        color: #495057;
        border: 1px solid #e9ecef;
      }

      .btn-outline:hover {
        background: #f8f9fa;
        border-color: #E5332A;
        color: #E5332A;
      }

      .btn-success {
        background: #4CAF50;
        color: white;
      }

      .btn-success:hover {
        background: #45a049;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
      }

      .btn-danger {
        background: #E5332A;
        color: white;
      }

      .btn-danger:hover {
        background: #c72a22;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(229, 51, 42, 0.3);
      }

      .btn-sm {
        padding: 0.5rem 0.875rem;
        font-size: 13px;
      }

      .btn-icon {
        padding: 0.75rem;
        border: 1px solid #e9ecef;
        background: white;
        color: #495057;
      }

      .btn-icon:hover {
        background: #f8f9fa;
        border-color: #E5332A;
        color: #E5332A;
      }

      /* ==================== PRODUCTS GRID ==================== */
      .products-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
        gap: 1.5rem;
      }

      /* ==================== LOADING & EMPTY STATES ==================== */
      .loading-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
        gap: 1.5rem;
      }

      .skeleton-card {
        height: 400px;
        background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
        background-size: 200% 100%;
        animation: loading 1.5s infinite;
        border-radius: 12px;
      }

      @keyframes loading {
        0% { background-position: 200% 0; }
        100% { background-position: -200% 0; }
      }

      .empty-state {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 4rem 2rem;
        text-align: center;
        background: white;
        border-radius: 12px;
        min-height: 400px;
      }

      .empty-state svg {
        margin-bottom: 1.5rem;
        opacity: 0.5;
      }

      .empty-state p {
        font-size: 16px;
        color: #868e96;
        margin: 0;
      }

      /* ==================== QUICK INFO GRID ==================== */
      .quick-info-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
        gap: 1.5rem;
        margin-top: 2rem;
      }

      .info-card {
        background: white;
        padding: 1.5rem;
        border-radius: 12px;
        border: 2px solid #e9ecef;
      }

      .info-card h3 {
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 1rem;
        color: #2B2B2B;
      }

      .info-list {
        display: flex;
        flex-direction: column;
        gap: 0.75rem;
      }

      .info-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0.75rem;
        background: #f8f9fa;
        border-radius: 8px;
      }

      .info-name {
        font-size: 14px;
        color: #495057;
        flex: 1;
      }

      .info-badge {
        padding: 0.25rem 0.75rem;
        border-radius: 6px;
        font-size: 12px;
        font-weight: 700;
      }

      .info-badge.discount {
        background: rgba(229, 51, 42, 0.1);
        color: #E5332A;
      }

      .info-badge.warning {
        background: rgba(245, 158, 11, 0.1);
        color: #f59e0b;
      }

      .info-badge.success {
        background: rgba(6, 214, 160, 0.1);
        color: #06d6a0;
      }

      /* ==================== DISCOUNT & CAMPAIGN CARDS ==================== */
      .discount-summary {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
        gap: 1.5rem;
        margin-bottom: 2rem;
      }

      .summary-card {
        display: flex;
        align-items: center;
        gap: 1.5rem;
        background: white;
        padding: 1.5rem;
        border-radius: 12px;
        border: 2px solid #e9ecef;
      }

      .summary-icon {
        width: 60px;
        height: 60px;
        border-radius: 12px;
        background: linear-gradient(135deg, rgba(229, 51, 42, 0.1), rgba(255, 107, 107, 0.1));
        display: flex;
        align-items: center;
        justify-content: center;
        color: #E5332A;
      }

      .summary-content h3 {
        font-size: 24px;
        font-weight: 700;
        color: #2B2B2B;
        margin-bottom: 0.25rem;
      }

      .summary-content p {
        font-size: 13px;
        color: #868e96;
        margin: 0;
      }

      .discount-list, .campaigns-grid {
        display: grid;
        gap: 1.5rem;
      }

      .discount-item {
        display: flex;
        align-items: center;
        gap: 1.5rem;
        background: white;
        padding: 1.5rem;
        border-radius: 12px;
        border: 2px solid #e9ecef;
      }

      .discount-item-image {
        width: 80px;
        height: 80px;
        border-radius: 8px;
        object-fit: cover;
      }

      .discount-item-content {
        flex: 1;
      }

      .discount-item-content h4 {
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 0.5rem;
        color: #2B2B2B;
      }

      .discount-item-category {
        font-size: 13px;
        color: #868e96;
        margin-bottom: 0.75rem;
      }

      .discount-item-prices {
        display: flex;
        align-items: center;
        gap: 1rem;
      }

      .old-price {
        font-size: 14px;
        color: #868e96;
        text-decoration: line-through;
      }

      .new-price {
        font-size: 18px;
        font-weight: 700;
        color: #E5332A;
      }

      .discount-badge {
        background: linear-gradient(135deg, #E5332A, #ff6b6b);
        color: white;
        padding: 0.25rem 0.75rem;
        border-radius: 6px;
        font-size: 12px;
        font-weight: 700;
      }

      .discount-date {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        font-size: 12px;
        color: #868e96;
        margin-top: 0.5rem;
      }

      /* ==================== CAMPAIGN CARDS ==================== */
      .campaigns-grid {
        grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
      }

      .campaign-card {
        background: white;
        border-radius: 12px;
        border: 2px solid #e9ecef;
        overflow: hidden;
        transition: all 0.3s;
      }

      .campaign-card:hover {
        transform: translateY(-4px);
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
      }

      .campaign-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 1.5rem;
        background: linear-gradient(135deg, rgba(229, 51, 42, 0.05), rgba(255, 107, 107, 0.05));
      }

      .campaign-badge {
        background: linear-gradient(135deg, #E5332A, #ff6b6b);
        color: white;
        padding: 0.5rem 1rem;
        border-radius: 8px;
        font-size: 18px;
        font-weight: 700;
      }

      .campaign-status {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0.5rem 1rem;
        border-radius: 8px;
        font-size: 13px;
        font-weight: 600;
      }

      .campaign-status.status-active {
        background: rgba(6, 214, 160, 0.1);
        color: #06d6a0;
      }

      .campaign-status.status-expired {
        background: rgba(229, 51, 42, 0.1);
        color: #E5332A;
      }

      .campaign-content {
        padding: 1.5rem;
      }

      .campaign-title {
        font-size: 18px;
        font-weight: 700;
        color: #2B2B2B;
        margin-bottom: 0.75rem;
      }

      .campaign-desc {
        font-size: 14px;
        color: #868e96;
        margin-bottom: 1.5rem;
        line-height: 1.6;
      }

      .campaign-info {
        display: flex;
        flex-direction: column;
        gap: 0.75rem;
        margin-bottom: 1.5rem;
      }

      .campaign-info-item {
        display: flex;
        align-items: center;
        gap: 0.75rem;
        font-size: 13px;
        color: #495057;
      }

      .campaign-actions {
        display: flex;
        gap: 0.75rem;
      }

      .campaign-actions .btn {
        flex: 1;
      }

      /* ==================== ANALYTICS ==================== */
      .analytics-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
        gap: 1.5rem;
      }

      .analytics-card {
        background: white;
        padding: 1.5rem;
        border-radius: 12px;
        border: 2px solid #e9ecef;
      }

      .analytics-card h3 {
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 1.5rem;
        color: #2B2B2B;
      }

      .chart-list {
        display: flex;
        flex-direction: column;
        gap: 1rem;
      }

      .chart-item {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
      }

      .chart-label {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        color: #495057;
      }

      .chart-value {
        font-weight: 700;
        color: #2B2B2B;
      }

      .chart-bar {
        width: 100%;
        height: 8px;
        background: #f0f0f0;
        border-radius: 4px;
        overflow: hidden;
      }

      .chart-fill {
        height: 100%;
        background: linear-gradient(135deg, #E5332A, #ff6b6b);
        border-radius: 4px;
        transition: width 0.3s ease;
      }

      /* ==================== ORDERS, CUSTOMERS, FINANCE CARDS ==================== */
      .orders-list,
      .customers-grid {
        display: grid;
        gap: 1.5rem;
      }

      .customers-grid {
        grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
      }

      /* ==================== SETTINGS ==================== */
      .settings-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
        gap: 1.5rem;
      }

      .settings-card {
        background: white;
        padding: 1.5rem;
        border-radius: 12px;
        border: 2px solid #e9ecef;
      }

      .settings-card h3 {
        font-size: 18px;
        margin-bottom: 1.5rem;
      }

      /* ==================== MODALS ==================== */
      .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.6);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1000;
        padding: 1rem;
      }

      .modal {
        background: white;
        border-radius: 16px;
        width: 100%;
        max-width: 600px;
        max-height: 90vh;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
      }

      .modal-large {
        max-width: 900px;
      }

      .modal-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 1.5rem 2rem;
        border-bottom: 2px solid #f0f0f0;
      }

      .modal-header h3 {
        font-size: 20px;
        font-weight: 700;
        color: #2B2B2B;
      }

      .close-btn {
        background: none;
        border: none;
        cursor: pointer;
        padding: 0.5rem;
        border-radius: 8px;
        transition: all 0.2s;
        color: #868e96;
      }

      .close-btn:hover {
        background: #f8f9fa;
        color: #E5332A;
      }

      .modal-body {
        padding: 2rem;
        overflow-y: auto;
        flex: 1;
      }

      .modal-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 1.5rem 2rem;
        border-top: 2px solid #f0f0f0;
        gap: 1rem;
      }

      .footer-actions-left {
        display: flex;
        gap: 0.75rem;
      }

      /* ===== KATEGORİ SİSTEMİ İÇİN EK CSS STİLLERİ ===== */

/* Category Selector */
.category-selector-wrapper {
  position: relative;
}

.category-selector-button {
  width: 100%;
  padding: 0.75rem 1rem;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  background: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  fontSize: 14px;
  transition: all 0.2s;
  font-family: inherit;
}

.category-selector-button:hover {
  border-color: #E5332A;
  background: #fff5f5;
}

.category-selector-button:focus {
  outline: none;
  border-color: #E5332A;
  box-shadow: 0 0 0 3px rgba(229, 51, 42, 0.1);
}

.category-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin-top: 0.5rem;
  background: white;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  max-height: 400px;
  overflow: auto;
  z-index: 1000;
  display: grid;
  gap: 0;
}

.category-dropdown::-webkit-scrollbar {
  width: 8px;
}

.category-dropdown::-webkit-scrollbar-track {
  background: #f8f9fa;
}

.category-dropdown::-webkit-scrollbar-thumb {
  background: #dee2e6;
  border-radius: 4px;
}

.category-dropdown::-webkit-scrollbar-thumb:hover {
  background: #adb5bd;
}

.main-categories {
  border-right: 1px solid #e9ecef;
}

.category-option {
  width: 100%;
  padding: 0.75rem 1rem;
  border: none;
  background: transparent;
  text-align: left;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  transition: all 0.2s;
  border-bottom: 1px solid #f0f0f0;
  font-family: inherit;
}

.category-option:hover {
  background: #f8f9fa;
}

.category-option:last-child {
  border-bottom: none;
}

/* Product Card Category Display */
.product-category {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
  padding: 0.25rem 0.5rem;
  background: #f8f9fa;
  border-radius: 6px;
  font-size: 12px;
  width: fit-content;
}

.category-emoji {
  font-size: 16px;
  line-height: 1;
}

.category-text {
  color: #495057;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px;
}

/* Select Dropdown with Emojis */
.select option {
  padding: 0.5rem;
}

/* Product Card Enhancements */
.product-card {
  position: relative;
  background: white;
  border: 2px solid #e9ecef;
  border-radius: 12px;
  padding: 1rem;
  transition: all 0.3s;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.product-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0,0,0,0.12);
  border-color: #E5332A;
}

.product-card.selected {
  border-color: #E5332A;
  background: #fff5f5;
  box-shadow: 0 4px 12px rgba(229, 51, 42, 0.15);
}

.product-selection {
  position: absolute;
  top: 0.75rem;
  left: 0.75rem;
  z-index: 10;
}

.product-selection input[type="checkbox"] {
  width: 20px;
  height: 20px;
  cursor: pointer;
  accent-color: #E5332A;
}

.product-image {
  position: relative;
  width: 100%;
  height: 200px;
  border-radius: 8px;
  overflow: hidden;
  background: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
}

.product-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 0.5rem;
}

.no-image {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
}

.discount-badge {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  background: linear-gradient(135deg, #E5332A, #ff6b6b);
  color: white;
  padding: 0.4rem 0.75rem;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  box-shadow: 0 2px 8px rgba(229, 51, 42, 0.3);
}

.status-badge {
  position: absolute;
  bottom: 0.5rem;
  right: 0.5rem;
  padding: 0.4rem 0.75rem;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
}

.status-badge.inactive {
  background: #868e96;
  color: white;
}

.featured-badge {
  position: absolute;
  bottom: 0.5rem;
  left: 0.5rem;
  background: linear-gradient(135deg, #FFD700, #FFA500);
  color: white;
  padding: 0.4rem 0.75rem;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.product-info {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex: 1;
}

.product-name {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #2B2B2B;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 42px;
}

.product-meta {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  flex-wrap: wrap;
  font-size: 11px;
}

.meta-brand {
  background: #e9ecef;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  color: #495057;
  font-weight: 600;
}

.meta-sku {
  color: #868e96;
  font-family: 'Courier New', monospace;
}

.product-price {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 18px;
  font-weight: 700;
  margin: 0.25rem 0;
}

.price-old {
  color: #868e96;
  text-decoration: line-through;
  font-size: 14px;
  font-weight: 500;
}

.price-new {
  color: #E5332A;
}

.price-current {
  color: #2B2B2B;
}

.product-stock {
  margin-top: 0.5rem;
}

.stock-bar {
  width: 100%;
  height: 6px;
  background: #e9ecef;
  border-radius: 3px;
  overflow: hidden;
  margin-bottom: 0.5rem;
}

.stock-fill {
  height: 100%;
  transition: width 0.3s;
}

.stock-instock .stock-fill {
  background: linear-gradient(90deg, #4CAF50, #66BB6A);
}

.stock-lowstock .stock-fill {
  background: linear-gradient(90deg, #FF9800, #FFB74D);
}

.stock-outofstock .stock-fill {
  background: linear-gradient(90deg, #E5332A, #ff6b6b);
}

.stock-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
}

.stock-count {
  color: #495057;
  font-weight: 600;
}

.stock-warning {
  color: #FF9800;
  font-size: 11px;
  font-weight: 700;
}

.stock-danger {
  color: #E5332A;
  font-size: 11px;
  font-weight: 700;
}

.product-sales {
  font-size: 12px;
  color: #495057;
  padding: 0.5rem;
  background: #f8f9fa;
  border-radius: 6px;
  text-align: center;
}

.product-actions {
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  padding-top: 0.5rem;
  border-top: 1px solid #e9ecef;
}

.action-btn {
  padding: 0.5rem;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  background: white;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
}

.action-btn:hover {
  transform: scale(1.05);
}

.btn-view {
  color: #2196F3;
}

.btn-view:hover {
  background: #E3F2FD;
  border-color: #2196F3;
}

.btn-edit {
  color: #4CAF50;
}

.btn-edit:hover {
  background: #E8F5E9;
  border-color: #4CAF50;
}

.btn-discount {
  color: #FF9800;
}

.btn-discount:hover {
  background: #FFF3E0;
  border-color: #FF9800;
}

.btn-delete {
  color: #E5332A;
}

.btn-delete:hover {
  background: #FFEBEE;
  border-color: #E5332A;
}

/* Results Info */
.results-info {
  padding: 1.5rem;
  text-align: center;
  color: #495057;
  font-size: 14px;
  border-top: 2px solid #e9ecef;
  margin-top: 2rem;
}

.results-info strong {
  color: #E5332A;
  font-weight: 700;
}

/* Empty State */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  text-align: center;
  color: #868e96;
}

.empty-state svg {
  margin-bottom: 1rem;
  opacity: 0.5;
}

.empty-state p {
  margin: 0 0 1rem;
  font-size: 16px;
}

/* Loading Grid */
.loading-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1.5rem;
  margin-top: 1.5rem;
}

.skeleton-card {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 12px;
  height: 400px;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

/* Products Grid */
.products-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1.5rem;
  margin-top: 1.5rem;
}

@media (max-width: 768px) {
  .products-grid {
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: 1rem;
  }
  
  .product-image {
    height: 160px;
  }
}

/* Spin Animation for Refresh */
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.spin {
  animation: spin 1s linear infinite;
}

.spinner-small {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Modal Enhancement */
.info-box {
  padding: 1rem;
  border-radius: 8px;
  margin-bottom: 1rem;
}

/* Category Dropdown Overlay */
.category-dropdown-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
}

/* Select with Emoji Support */
.select {
  font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
}

/* Toolbar Enhancements */
.toolbar-section {
  display: flex;
  gap: 0.75rem;
  align-items: center;
  flex-wrap: wrap;
}

.select-wrapper {
  min-width: 180px;
}

@media (max-width: 1200px) {
  .toolbar-section {
    width: 100%;
  }
  
  .select-wrapper {
    flex: 1;
    min-width: 140px;
  }
}

      /* ==================== FORM ELEMENTS ==================== */
      .form-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 2rem;
      }

      .form-column {
        display: flex;
        flex-direction: column;
        gap: 1.25rem;
      }

      .form-group {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        margin-top: 16px;
      }

      .form-row {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 1rem;
      }

      .form-label {
        font-size: 14px;
        font-weight: 600;
        color: #495057;
      }

      .form-input {
        padding: 0.875rem 1rem;
        border: 1px solid #e9ecef;
        border-radius: 8px;
        font-size: 14px;
        color: #2B2B2B;
        transition: all 0.2s;
        font-family: inherit;
      }

      .form-input:hover {
        border-color: #E5332A;
      }

      .form-input:focus {
        outline: none;
        border-color: #E5332A;
        box-shadow: 0 0 0 3px rgba(229, 51, 42, 0.1);
      }

      textarea.form-input {
        resize: vertical;
        min-height: 100px;
      }

      .checkbox-label {
        display: flex;
        align-items: center;
        gap: 0.75rem;
        cursor: pointer;
        user-select: none;
      }

      .checkbox-label input[type="checkbox"] {
        width: 18px;
        height: 18px;
        cursor: pointer;
      }

      .image-upload-area {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        padding: 1.5rem;
        border: 2px dashed #e9ecef;
        border-radius: 8px;
        text-align: center;
      }

      .image-preview {
        max-width: 100%;
        max-height: 200px;
        border-radius: 8px;
        object-fit: contain;
        margin: 0 auto;
      }

      .upload-hint {
        font-size: 13px;
        color: #868e96;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.5rem;
      }

      .discount-info {
        display: flex;
        align-items: center;
        gap: 1rem;
        padding: 1rem;
        background: rgba(229, 51, 42, 0.05);
        border-radius: 8px;
        margin-bottom: 1.5rem;
      }

      .discount-info p {
        margin: 0;
        font-size: 14px;
        color: #495057;
      }

      .discount-preview {
        padding: 1rem;
        background: #f8f9fa;
        border-radius: 8px;
        margin-top: 1rem;
      }

      .preview-prices {
        display: flex;
        align-items: center;
        gap: 1rem;
        margin-top: 0.5rem;
      }

      .preview-old {
        font-size: 18px;
        color: #868e96;
        text-decoration: line-through;
      }

      .preview-arrow {
        font-size: 18px;
        color: #E5332A;
      }

      .preview-new {
        font-size: 20px;
        font-weight: 700;
        color: #E5332A;
      }

      /* ==================== İPTAL VE İADE (YENİ) ==================== */
      .sub-tabs {
        display: flex;
        gap: 0.5rem;
        margin-bottom: 1.5rem;
        border-bottom: 2px solid #e9ecef;
        padding-bottom: 0;
      }

      .sub-tab {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0.75rem 1.5rem;
        background: none;
        border: none;
        border-bottom: 3px solid transparent;
        color: #495057;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s;
        margin-bottom: -2px;
        font-size: 14px;
        border-radius: 8px 8px 0 0;
      }

      .sub-tab:hover {
        color: #E5332A;
        background: rgba(229, 51, 42, 0.05);
      }

      .sub-tab.active {
        color: white;
        background: #E5332A;
        border-bottom-color: #E5332A;
      }

      .requests-list {
        display: grid;
        gap: 1.5rem;
      }

      .request-card {
        background: white;
        border: 2px solid #e9ecef;
        border-radius: 12px;
        padding: 1.5rem;
        transition: all 0.3s;
      }

      .request-card:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        border-color: #E5332A;
      }

      .request-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 1rem;
        padding-bottom: 1rem;
        border-bottom: 1px solid #f0f0f0;
      }

      .request-info h4 {
        margin: 0 0 0.5rem;
        font-size: 18px;
        color: #2B2B2B;
        font-weight: 700;
      }

      .request-date {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        font-size: 13px;
        color: #868e96;
      }

      .request-status {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0.5rem 1rem;
        border-radius: 8px;
        font-size: 13px;
        font-weight: 600;
      }

      .request-status.status-pending {
        background: #fff3cd;
        color: #856404;
      }

      .request-status.status-approved {
        background: #d4edda;
        color: #155724;
      }

      .request-status.status-rejected {
        background: #f8d7da;
        color: #721c24;
      }

      .request-status.status-received {
        background: #d1ecf1;
        color: #0c5460;
      }

      .request-status.status-completed {
        background: #d4edda;
        color: #155724;
      }

      .request-customer,
      .request-reason,
      .request-amount {
        display: flex;
        align-items: flex-start;
        gap: 0.75rem;
        margin-bottom: 1rem;
        padding: 0.75rem;
        background: #f8f9fa;
        border-radius: 8px;
      }

      .request-customer svg,
      .request-reason svg,
      .request-amount svg {
        flex-shrink: 0;
        margin-top: 2px;
        color: #868e96;
      }

      .request-reason strong,
      .request-amount strong {
        display: block;
        margin-bottom: 4px;
        color: #2B2B2B;
      }

      .reason-detail {
        margin: 0.5rem 0 0;
        font-size: 13px;
        color: #666;
        font-style: italic;
        line-height: 1.6;
      }

      .refund-method {
        font-size: 12px;
        color: #868e96;
        margin-left: 0.5rem;
      }

      .defect-info {
        margin-top: 0.5rem;
        padding: 0.75rem;
        background: #fff3cd;
        border-left: 3px solid #ffc107;
        border-radius: 6px;
        font-size: 13px;
        line-height: 1.6;
      }

      .request-actions {
        display: flex;
        gap: 0.75rem;
        margin-top: 1rem;
        padding-top: 1rem;
        border-top: 1px solid #f0f0f0;
      }

      .request-actions .btn {
        flex: 1;
      }

      .request-note {
        padding: 1rem;
        border-radius: 8px;
        font-size: 14px;
        margin-top: 1rem;
        line-height: 1.6;
      }

      .request-note.approved {
        background: #d4edda;
        color: #155724;
        border: 2px solid #4CAF50;
      }

      .request-note.rejected {
        background: #f8d7da;
        color: #721c24;
        border: 2px solid #E5332A;
      }

      .request-note.info {
        background: #d1ecf1;
        color: #0c5460;
        border: 2px solid #17a2b8;
      }

      .request-note.completed {
        background: #d4edda;
        color: #155724;
        border: 2px solid #4CAF50;
      }

      .request-note p {
        margin: 0.5rem 0 0;
        font-size: 13px;
      }

      .info-box {
        padding: 1rem;
        border-radius: 8px;
        margin-bottom: 1rem;
        display: flex;
        gap: 0.75rem;
      }

      .info-box.warning {
        background: #fff3cd;
        border: 2px solid #ffc107;
      }

      .info-box.success {
        background: #d4edda;
        border: 2px solid #4CAF50;
      }

      .info-box.info {
        background: #d1ecf1;
        border: 2px solid #17a2b8;
      }

      .info-box p {
        margin: 0;
        font-size: 14px;
        line-height: 1.6;
      }

      .info-box h4 {
        margin: 0 0 0.75rem;
        font-size: 14px;
      }

      .info-box ol {
        margin: 0;
        padding-left: 1.25rem;
        font-size: 13px;
        line-height: 1.8;
      }

      /* ==================== BULK ACTIONS BAR ==================== */
      .bulk-actions-bar {
        position: fixed;
        bottom: 2rem;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        align-items: center;
        gap: 1rem;
        background: white;
        padding: 1rem 2rem;
        border-radius: 12px;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
        z-index: 999;
      }

      .bulk-info {
        font-size: 14px;
        font-weight: 600;
        color: #2B2B2B;
      }

      /* ==================== ANIMATIONS ==================== */
      .spin {
        animation: spin 1s linear infinite;
      }

      @keyframes spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
      }

      /* ==================== RESPONSIVE ==================== */
      @media (max-width: 1024px) {
        .form-grid {
          grid-template-columns: 1fr;
        }

        .analytics-grid {
          grid-template-columns: 1fr;
        }
      }

      @media (max-width: 768px) {
        .menu-btn {
          display: block;
        }

        .sidebar {
          position: fixed;
          left: 0;
          top: 0;
          bottom: 0;
          z-index: 999;
          transform: translateX(-100%);
        }

        .sidebar.open {
          transform: translateX(0);
        }

        .sidebar-overlay.active {
          display: block;
        }

        .main-content {
          padding: 1rem;
        }

        .admin-header h1 {
          font-size: 16px;
        }

        .page-title {
          font-size: 22px;
        }

        .stats-grid {
          grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
        }

        .products-grid {
          grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
        }

        .toolbar {
          flex-direction: column;
          align-items: stretch;
        }

        .toolbar-section {
          width: 100%;
          justify-content: space-between;
        }

        .search-bar {
          width: 100%;
        }

        .form-row {
          grid-template-columns: 1fr;
        }

        .modal {
          max-height: 95vh;
        }

        .modal-body {
          padding: 1.5rem;
        }

        .campaigns-grid,
        .customers-grid {
          grid-template-columns: 1fr;
        }

        .bulk-actions-bar {
          left: 1rem;
          right: 1rem;
          transform: none;
          flex-direction: column;
        }
      }

      /* ==================== SCROLL BARS ==================== */
      ::-webkit-scrollbar {
        width: 8px;
        height: 8px;
      }

      ::-webkit-scrollbar-track {
        background: #f1f1f1;
      }

      ::-webkit-scrollbar-thumb {
        background: #E5332A;
        border-radius: 4px;
      }

      ::-webkit-scrollbar-thumb:hover {
        background: #c72a22;
      }
    `}</style>
  );
}